export default "static/src/images/Chi-siamo_red.jpg";